import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import MediaQuery from 'react-responsive'
import { styled, theme } from '$utils/theme'
import { Block } from './Block'
import { Link } from '../Link'
import { rem } from 'polished'
import { routeProvider } from '$utils/routeProvider'
import { Icon } from '../Icon'

const logo = require('$icons/logoFamiliados.svg')
const logoKids = require('$icons/logoKidsFamiliados.svg')

const HeaderWrapper = styled(Block)`
  width: 100%;
  height: ${rem(72)};
  border-bottom: solid 1px ${p => p.theme.colors.lightGrey};
  background-color: white;
  position: fixed;
  z-index: 2;
`

const HeaderDiv = styled(Block)`
  padding: ${p => rem(p.theme.sizes.base)};
  padding-left: ${p => rem(p.theme.sizes.mini)};
  ${p =>
    p.theme.media.onlyMobile`
      padding-bottom: 0;
      height: 50px;
      border-bottom: solid 1px ${p.theme.colors.lightGrey};
    `};
  height: 71px;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 2;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1160px;
  margin: auto;
  left: 0;
  right: 0;
  ${p => p.theme.media.onlyMobile`
    padding-right: ${rem(p.theme.sizes.mini)};
    padding-left: ${rem(p.theme.sizes.mini)};
  `};
`

const HeaderLogo = styled.div`
  display: inline-flex;
  flex-grow: 1;

  ${p =>
    p.theme.media.onlyMobile`
      padding-left: 0;
      img {
        padding-top: 4px;
      };
    `};
  ${p =>
    p.theme.media.desktop`
      margin-top: 7px;
      img {
        transform: scale(1);
      }
    `};
`

const DesktopHeaderRaw: React.SFC<RouteComponentProps<any> & Props> = ({ kids }) => (
  <HeaderWrapper>
    <HeaderDiv marginBottom="base">
      <HeaderLogo>
        <Link href={routeProvider.mainPage} title="Familiados">
          {kids ? <Icon content={logoKids} logo kids /> : <Icon content={logo} logo color="darkGrey" />}
        </Link>
      </HeaderLogo>
    </HeaderDiv>
  </HeaderWrapper>
)

const MobileHeaderRaw: React.SFC<RouteComponentProps<any> & Props> = ({ kids }) => (
  <HeaderDiv>
    <HeaderLogo>
      <Link href={routeProvider.mainPage} title="Familiados">
        {kids ? <Icon content={logoKids} logo kids /> : <Icon content={logo} logo color="darkGrey" />}
      </Link>
    </HeaderLogo>
  </HeaderDiv>
)
const DesktopHeader = withRouter(DesktopHeaderRaw)

const MobileHeader = withRouter(MobileHeaderRaw)

const HeaderRaw: React.SFC<RouteComponentProps<any> & Props> = ({ kids }) => (
  <>
    <MediaQuery minWidth={theme.breakpoints.desktop}>
      <DesktopHeader kids={kids} />
    </MediaQuery>
    <MediaQuery maxWidth={theme.breakpoints.desktop - 1}>
      <MobileHeader kids={kids} />
    </MediaQuery>
  </>
)

export const PublicHeader = withRouter(HeaderRaw)



// WEBPACK FOOTER //
// ./src/views/components/Layout/PublicHeader.tsx